module.exports = __webpack_public_path__ + "img/news_page_boy_article_full.26ef34f9.png";